<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id
      }"
    />
    <div :class="['form-control signature-field', { disabled }]">
      <div
        v-if="signature"
        class="d-flex align-items-center"
      >
        <span
          :class="['signature-canvas', { 'signature-pointer': canRedo }]"
          @click="canRedo && openSignModal()"
        >{{ signature }}</span>
        <div class="signature-details">
          <p class="mb-2"><small>Digitally signed by {{ signature }}</small></p>
          <p class="mb-0"><small>Date: {{ timestamp | format('M/D/YYYY h:mm a') }}</small></p>
        </div>
      </div>
      <AppButton
        v-else
        :raised="true"
        :disabled="disabled"
        @click="openSignModal"
      >Click here to sign</AppButton>
      <AppModal
        v-if="isSignOpen"
        ref="modal"
        :showX="false"
        @close="closed"
      >
        <template #modal-body>
          <div
            v-if="fillByTyping"
            class="d-flex align-items-center justify-content-center"
          >
            <AppIcon name="keyboard" />
            <span class="ml-1">
              Type to sign
            </span>
          </div>
          <div class="signature-wrapper mt-4 mb-2 py-4">
            <input
              v-model="signatureName"
              type="text"
              class="signature-input"
              :disabled="!fillByTyping"
            />
          </div>
        </template>
        <template slot="modal-footer">
          <div class="w-100 d-flex align-items-center justify-content-center">
            <AppButton
              variant="secondary"
              @click="close"
            >Cancel</AppButton>
            <AppButton
              raised
              :disabled="!signatureName"
              @click="update"
            >I Approve
            </AppButton>
          </div>
        </template>
      </AppModal>
    </div>
  </div>
</template>

<script>
import FormMixin from './FormMixin'
import { mapGetters } from 'vuex'
import FormLabel from './FormLabel'

export default {
  name: 'FormSignature',
  mixins: [ FormMixin ],
  components: { FormLabel },
  props: {
    value: {
      default: () => ({}),
      type: Object,
    },
    fillByTyping: {
      default: false,
      type: Boolean,
    },
  },
  data () {
    return {
      isSignOpen: false,
      signatureName: '',
    }
  },
  computed: {
    ...mapGetters([ 'user' ]),
    canRedo () {
      return !this.disabled && this.fillByTyping
    },
    userId () {
      return this.value.userId
    },
    fullName () {
      return `${this.user.firstName} ${this.user.lastName}`
    },
    signature () {
      return this.value.signature
    },
    timestamp () {
      return this.value.timestamp
    },
  },
  methods: {
    update (signature) {
      this.close()
      this.$emit('input', {
        signature: this.signatureName,
        userId: this.userId || this.user.id,
        timestamp: Date.now(),
      })
    },
    openSignModal () {
      this.isSignOpen = true
      this.signatureName = this.fillByTyping ? (this.signature || '') : this.fullName
    },
    close () {
      if (!this.$refs.modal) return
      this.$refs.modal.close()
    },
    closed () {
      this.isSignOpen = false
    },
  },
}
</script>

<style scoped>
.signature-field {
  background-image: none;
}
.signature-input,
.signature-canvas {
  font-family: "Allura", cursive;
}
.signature-canvas {
  border-right: 1px solid black;
  padding-right: 0.75rem;
  margin-right: 0.5rem;
  font-size: 40px;
}
.signature-wrapper {
  background: var(--light-gray);
  margin: auto;
  width: 75%;
}
.signature-input {
  width: 100%;
  text-align: center;
  font-size: 40px;
  background: transparent;
  border: none;
  border-bottom: 1px solid black;
  display: block;
}
.signature-pointer {
  cursor: pointer;
}
</style>
